var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const TOKEN = 'token';
const ACCOUNT_ID = 'accountId';
const NAME = 'name';
const BIND_INFO = 'bindInfo';
class Auth {
    constructor(app) {
        this.app = app;
    }
    getToken() {
        return this.token;
    }
    getAccountId() {
        return this.accountId;
    }
    getName() {
        return this.name;
    }
    getBindInfo() {
        return this.bindInfo;
    }
    setToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.storage.setItem(TOKEN, token);
            this.token = token;
        });
    }
    setName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.storage.setItem(NAME, name);
            this.name = name;
        });
    }
    setAccountId(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.storage.setItem(ACCOUNT_ID, accountId);
            this.accountId = accountId;
        });
    }
    setBindInfo(bindInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.storage.setItem(BIND_INFO, bindInfo);
            this.bindInfo = bindInfo;
        });
    }
    initByStorage() {
        return __awaiter(this, void 0, void 0, function* () {
            this.token = yield this.app.storage.getItem(TOKEN);
            this.name = yield this.app.storage.getItem(NAME);
            this.accountId = yield this.app.storage.getItem(ACCOUNT_ID);
            this.bindInfo = yield this.app.storage.getItem(BIND_INFO);
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.storage.removeItem(TOKEN);
            yield this.app.storage.removeItem(NAME);
            yield this.app.storage.removeItem(ACCOUNT_ID);
            yield this.app.storage.removeItem(BIND_INFO);
            this.accountId = undefined;
            this.bindInfo = undefined;
            this.name = undefined;
            this.token = undefined;
        });
    }
}
export default Auth;
